import { Navigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";

const ProtectedRoute = ({ children }) => {
  const { token } = useApp();
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
};

export default ProtectedRoute;
